import React from 'react'
import Header from '../component/header'
import BannerImg from '../image/donation.png'
import Banner from '../component/Banner'
import Footer from '../component/Footer'
import Support from '../component/donation/Support'
import Where from '../component/donation/Where'
import Choose from '../component/donation/Choose'
import Spotlight from '../component/Spotlight'

const Donation = () => {
  return (
     <>
    <Header />
          <Banner
            backgroundImage={BannerImg}
            heading="Donate Now"
            paragraph="Lightweave Beacon Legacy believes that every artist deserves guidance, not from gatekeepers, but from mentors, peers, and shared learning. Our education programs provide structured study, tutorials, critique insights, and learning materials designed to elevate the craft across architecture, photography, sculpture, and technical design. Whether emerging or experienced, this is where creative skill matures into mastery."
            minHeight="100vh"
            padding="80px 0"
            bton="Members please sign-in"
          />
          <Support/>
          <Where/>
          <Choose/>
          <Spotlight/>
          <Footer />
    
    </>
  )
}

export default Donation
